import React from "react";
import classNames from "classnames";

import {
  TYPOGRAPHY_COLORS,
  TYPOGRAPHY_FONT_WEIGHTS,
  TYPOGRAPHY_VARIANTS
} from "./Typography.constants";

export type TypographyOwnProps<E extends React.ElementType = React.ElementType> = {
  children: React.ReactNode;
  fontWeight?: ArrayToUnion<typeof TYPOGRAPHY_FONT_WEIGHTS>;
  variant?: ArrayToUnion<typeof TYPOGRAPHY_VARIANTS>;
  textColor?: ArrayToUnion<typeof TYPOGRAPHY_COLORS>;
  customClassName?: string;
  as?: E;
};

export type TypographyProps<E extends React.ElementType> = TypographyOwnProps<E> &
  Omit<React.ComponentProps<E>, keyof TypographyOwnProps<E> | "className" | "ref">;

const Typography = React.forwardRef(
  <E extends React.ElementType = React.ElementType>(
    props: TypographyProps<E>,
    ref: React.ComponentPropsWithRef<E>["ref"]
  ) => {
    const {
      variant = "body",
      fontWeight,
      textColor = "text-main",
      children,
      customClassName,
      as: WrapperElement = "div",
      ...otherProps
    } = props;
    const Component = WrapperElement || "div";

    return (
      <Component
        ref={ref}
        className={classNames(
          "typography",
          `typography--${variant}`,
          `color--${textColor}`,
          {[`font-weight--${fontWeight}`]: fontWeight},
          customClassName
        )}
        {...otherProps}>
        {children}
      </Component>
    );
  }
);

export default Typography;
